import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { onlyNumbers } from '../../../../shared/utils/validate-number';

export const availableItemFields = {
  type: 'type',
  urlComparisonType: 'urlComparisonType',
  text: 'text',
  time: 'time',
  percent: 'percent',
  pages: 'pages',
  page: 'page'
};

@Injectable()
export class ItemService {
  private formFields = {
    [availableItemFields.type]: ['', Validators.required],
    [availableItemFields.urlComparisonType]: ['', Validators.required],
    [availableItemFields.text]: ['', [Validators.required, Validators.pattern('.*[^ ].*')]],
    [availableItemFields.time]: ['', [Validators.required, onlyNumbers]],
    [availableItemFields.percent]: ['', [Validators.required, onlyNumbers, Validators.min(0), Validators.max(100)]],
    [availableItemFields.pages]: [[], [Validators.required]],
    [availableItemFields.page]: ['', [Validators.required, Validators.pattern('.*[^ ].*')]]
  };

  constructor(private fb: FormBuilder) {}

  createForm(fieldsWithData: Object) {
    const form = this.fb.group({});
    Object.keys(fieldsWithData).forEach(field => {
      this.addField(form, {
        [field]: fieldsWithData[field]
      });
    });
    return form;
  }

  addField(form: FormGroup, field: object) {
    const key = Object.keys(field)[0];
    if (!form.get(key)) {
      if (field[key] instanceof Array) {
        form.addControl(key, this.prepareArray(field));
      } else {
        const validators = this.formFields[key][1];
        form.addControl(key, this.fb.control(field[key], validators as any));
      }
    }
  }

  prepareArray(field) {
    const key = Object.keys(field)[0];
    const arrayForm = this.fb.array([]);
    field[key].forEach(element => {
      arrayForm.push(this.createGroupItem(element));
    });
    return arrayForm;
  }

  createGroupItem(field) {
    const formFieldType = Object.keys(field)[0];
    const validators = this.formFields[formFieldType][1];
    return this.fb.group({
      [formFieldType]: [field[formFieldType], validators as any]
    });
  }
}
